import { Suspense } from "react";

import { FiinderProvider } from "./components/fiinder-provider";
import { LandingPage } from "./components/ui/landing-page/landing-page";
import { defaultPersonationContext } from "./lib/personation-context";
import { PdfViewerProvider } from "./components/ui/pdf-viewer/pdf-context";

function LandingApp() {
  return (
    <Suspense fallback={<div>Loading app...</div>}>
      <FiinderProvider
        fiinderApiUrl={defaultPersonationContext.apiUrl}
        companyToken={defaultPersonationContext.companyToken}
        agentName={defaultPersonationContext.botName}
        agentRole={defaultPersonationContext.botRole}
        agentAvatarUrl={defaultPersonationContext.botAvatarUrl}
        companyMainColor={defaultPersonationContext.companyMainColor}
        // introMessage="Wie kann ich Ihnen helfen?"
        introMessage={defaultPersonationContext.introMessage}
        introMessageMeta={defaultPersonationContext.introMessageMeta}
        promptSuggestionsTitle={
          defaultPersonationContext.promptSuggestionsTitle
        }
        promptSuggestions={defaultPersonationContext.promptSuggestions}
        launcherCallToAction={defaultPersonationContext.launcherCallToAction}
        launcherAvatarSize={defaultPersonationContext.launcherAvatarSize}
        linkTarget={defaultPersonationContext.linkTarget}
        searchPlaceholder={defaultPersonationContext.searchPlaceholder}
      >
        <PdfViewerProvider>
          <LandingPage logoUrl={defaultPersonationContext.botAvatarUrl} />
        </PdfViewerProvider>
      </FiinderProvider>
    </Suspense>
  );
}

export default LandingApp;
